import {FC} from 'react'
import {charge} from '../../core/_models'

type Props = {
  charge: charge
  colSpan: number
  isOpen: boolean
}

const DetailField: FC<{label: string; value: React.ReactNode}> = ({label, value}) => (
  <tr>
    <td className='text-black fw-bold min-w-125px w-125px'>{label}</td>
    <td className='text-gray-800'>{value ?? '-'}</td>
  </tr>
)

const ChargeDetailContent: FC<{charge: charge}> = ({charge}) => {
  const details = charge.chargeableDetails

  if (!details) {
    return <span className='text-muted'>Sem detalhes disponíveis para esta cobrança.</span>
  }

  switch (details.type) {
    case 'contract':
      return (
        <table className='table table-flush fw-semibold gy-1 mb-0'>
          <tbody>
            <DetailField label='Nome' value={`${details.clientName}`} />
            <DetailField label='Contrato' value={`#${details.contractId}`} />
            <DetailField label='Nome do arquivo' value={details.contractName} />
            <DetailField label='Nº Contrato' value={details.saleId ? `#${details.saleId}` : null} />
          </tbody>
        </table>
      )
    case 'tscorp_log':
      return (
        <table className='table table-flush fw-semibold gy-1 mb-0'>
          <tbody>
            <DetailField label='Método' value={details.method} />
            <DetailField label='URI' value={details.uri} />
            <DetailField label='Usuário' value={details.userName} />
          </tbody>
        </table>
      )
    case 'billing':
      return (
        <table className='table table-flush fw-semibold gy-1 mb-0'>
          <tbody>
            <DetailField label='Nome' value={`${details.clientName}`} />
            <DetailField label='Nome Pagador' value={`${details.paidByUserName}`} />
            <DetailField label='Nº Cobrança' value={`#${details.billingId}`} />
            <DetailField label='Nº Contrato' value={details.saleId ? `#${details.saleId}` : null} />
            <DetailField label='Forma de Pagamento' value={details.paymentOptionName} />
          </tbody>
        </table>
      )
    case 'billing_installment':
      return (
        <table className='table table-flush fw-semibold gy-1 mb-0'>
          <tbody>
            <DetailField label='Nome' value={`${details.clientName}`} />
            <DetailField label='Nome Pagador' value={`${details.paidByUserName}`} />

            <DetailField label='Parcela' value={`#${details.installmentId}`} />
            <DetailField label='Nº Parcela' value={details.installmentNumber} />
            <DetailField
              label='Nº Cobrança'
              value={details.billingId ? `#${details.billingId}` : null}
            />
            <DetailField label='Nº Contrato' value={details.saleId ? `#${details.saleId}` : null} />
            <DetailField label='Forma de Pagamento' value={details.paymentOptionName} />
          </tbody>
        </table>
      )
    case 'recurrence_installment':
      return (
        <table className='table table-flush fw-semibold gy-1 mb-0'>
          <tbody>
            <DetailField label='Nome' value={`${details.clientName}`} />
            <DetailField label='Nome Pagador' value={`${details.paidByUserName}`} />
            <DetailField label='Parcela' value={`#${details.installmentId}`} />
            <DetailField label='Nº Parcela' value={details.installmentNumber} />
            <DetailField
              label='Nº Cobrança'
              value={details.billingId ? `#${details.billingId}` : null}
            />
            <DetailField label='Nº Contrato' value={details.saleId ? `#${details.saleId}` : null} />
            <DetailField label='Forma de Pagamento' value={details.paymentOptionName} />
            <DetailField
              label='Cobrança Baixada'
              value={details.settledBillingId ? `#${details.settledBillingId}` : null}
            />
            <DetailField
              label='Forma de Pagamento (Baixa)'
              value={details.settledPaymentOptionName}
            />
          </tbody>
        </table>
      )
    default:
      return <span className='text-muted'>Sem detalhes disponíveis para esta cobrança.</span>
  }
}

const ChargeDetailRow: FC<Props> = ({charge, colSpan, isOpen}) => {
  return (
    <tr className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
      <td colSpan={colSpan}>
        <div
          className='border border-gray-300 border-dashed rounded'
          style={{backgroundColor: 'rgb(249, 234, 233)'}}
        >
          <div className='container m-5'>
            <div className='d-flex flex-wrap py-5'>
              <div className='flex-equal me-5'>
                <ChargeDetailContent charge={charge} />
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  )
}

export {ChargeDetailRow}
